<template>
  <b-modal
    ok-only
    @hidden="modalHidden()"
    @shown="modalShown()"
    ref="loginModalRef"
    id="loginModalRef"
    v-model="modalIsVisible"
    hide-footer
    :title="$t('global.menu.login')"
  >
    <form class="form-signin" @submit.prevent="login" v-if="!showFacebookCreate">
      <div class="form-group">
        <label for="username" class="sr-only">{{$t('user.field.email')}}</label>
        <input
          ref="username"
          id="username"
          class="form-control"
          required
          v-model="username"
          type="text"
          :placeholder="$t('user.field.email')"
        >
      </div>
      <div class="form-group">
        <label class="sr-only">{{$t('user.field.password')}}</label>
        <input
          class="form-control"
          required
          v-model="password"
          type="password"
          :placeholder="$t('user.field.password')"
        >
      </div>
      <router-link
        @click.native="modalHidden"
        :to="{name: 'PasswordRecovery'}"
      >{{ $t('passwordRecovery.title') }}</router-link>
      <router-link
        @click.native="modalHidden"
        class="float-right"
        :to="{name: 'UserCreate'}"
      >{{ $t('global.menu.register') }}</router-link>
      <hr>
      <button class="btn btn-lg btn-primary btn-block" :disabled="loading" type="submit">{{$t('user.auth.login')}}</button>
      <button
        v-if="false"
        @click="facebookLogin"
        type="button"
        class="btn btn-primary mt-2 btn-block"
      >
        <font-awesome-icon :icon="['fab', 'facebook']"/>
        {{$t('user.facebook.loginButton')}}
      </button>
    </form>
    <form @submit.prevent="facebookCreate" v-if="showFacebookCreate">
      <p>{{$t('user.facebook.createAccountMessage')}}</p>
      <b-form-checkbox tag="b-form-checkbox" required>
        <i18n path="user.field.tos.text">
          <a :href="tosPdf" target="_blank">{{ $t('user.field.tos.label') }}</a>
        </i18n>
      </b-form-checkbox>
      <button
        type="submit"
        class="btn btn-primary mt-2 btn-block"
      >{{$t('user.facebook.createAccountButton')}}</button>
    </form>
  </b-modal>
</template>


<script>
import {mapGetters} from 'vuex';
import tosPdf from '../../assets/TOS.pdf';

export default {
    data: function() {
        return {
            username: null,
            password: null,
            modalIsVisible: false,
            tosPdf: tosPdf
        };
    },
    computed: {
        ...mapGetters('user/auth', [
            'loginFormVisible',
            'loginRequired',
            'logged',
        ]),
        ...mapGetters('user/facebookAuth', [
            'showFacebookCreate'
        ]),
        ...mapGetters('loading/loading', [
             'loading'
        ]),
    },
    watch: {
        loginFormVisible: function(newVal) {
            if (newVal) {
                this.showModal();
            } else {
                this.hideModal();
            }
        }
    },
    methods: {
        rediectToHome: function() {
            this.$router.push({name: 'PostList'});
        },
        facebookCreate: function() {
            let vue = this;
            FB.login(
                function(response) {
                    vue.$store.dispatch(
                        'user/facebookAuth/facebookCreate',
                        response.authResponse.accessToken
                    );
                },
                {scope: 'email'}
            );
        },
        facebookLogin: function() {
            let vue = this;
            FB.login(
                function(response) {
                    vue.$store.dispatch('user/facebookAuth/setToken', response.authResponse.accessToken);
                    vue.$store.dispatch(
                        'user/facebookAuth/login',
                        response.authResponse.accessToken
                    );
                },
                {scope: 'email'}
            );
        },
        login: function() {
            const {username, password} = this;
            this.$store
                .dispatch('user/auth/login', {username, password})
                .then(() => {
                    this.username = null;
                    this.password = null;
                    if (this.logged) {
                        this.rediectToHome();
                    }
                });
        },
        showModal() {
            this.modalIsVisible = true;
        },
        hideModal() {
            this.modalIsVisible = false;
        },
        modalHidden() {
            this.$store.dispatch('user/auth/hideModal');
            this.$store.dispatch('user/facebookAuth/hideFacebookForm');
        },
        modalShown() {
            this.$refs.username.focus();
        }
    },
    beforeMount() {
        if (this.loginFormVisible) {
            this.showModal();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/user/LoginModal.vue